{
  "_comment": "[CI-LOCKED] Fitxategi honen edukia blokeatuta dago. Ekarpenak onartzen dira, baina baliteke aldaketen balidazioa atzeratzea.",
  "ACCESS_KEY_ALT": "Alt + Maius + $1",
  "ACCESS_KEY_FOR_MAC_ALT": "Ktrl + Aukera + $1",
  "ACTIVITY_BOT_SAID_ALT": "$1 bot-ak hau esan du:",
  "ACTIVITY_STATUS_VOICE_TRANSCRIPT_AGENT_LABEL": "Agentea",
  "ACTIVITY_YOU_SAID_ALT": "Hau esan duzu:",
  "ACTIVITY_BOT_ATTACHED_ALT": "Bot-ak hau erantsi du:",
  "ACTIVITY_CODE_ALT": "Kode-lagina: $1",
  "ACTIVITY_CONTENT_CAUTION": "Adimen artifizialak sortutako edukia oker egon liteke",
  "ACTIVITY_CODE_CAUTION": "AAk sortutako kodea. Berrikus ezazu. eta arretaz erabili",
  "ACTIVITY_ERROR_BOX_TITLE": "Errore-mezua",
  "ACTIVITY_INTERACTIVE_FOOTNOTE_ALT": "Sakatu hau interakzioa hasteko.",
  "ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT": "Mezua interaktiboa da.",
  "ACTIVITY_INTERACTIVE_REASON_LINK_ALT": "Esteka bat edo gehiago dago mezuan.",
  "ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT": "Ezin izan da bidali.",
  "ACTIVITY_YOU_ATTACHED_ALT": "Hau erantsi duzu:",
  "ACTIVITY_NUM_ATTACHMENTS_ONE_ALT": "1 eranskin.",
  "ACTIVITY_NUM_ATTACHMENTS_FEW_ALT": "$1 eranskin.",
  "ACTIVITY_NUM_ATTACHMENTS_MANY_ALT": "$1 eranskin.",
  "ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT": "$1 eranskin.",
  "ACTIVITY_NUM_ATTACHMENTS_TWO_ALT": "$1 eranskin.",
  "ACTIVITY_STATUS_SEND_FAILED_RETRY": "Ezin izan da bidali. [Saiatu berriro][RETRY].",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING": "Bidaltzen",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT": "Bidaltze-ordua: $1",
  "ACTIVITY_STATUS_TIMESTAMP_JUST_NOW": "Oraintxe bertan",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO": "Duela ordubete",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO": "Duela minutu bat",
  "ACTIVITY_STATUS_TIMESTAMP_TODAY": "Gaur",
  "ACTIVITY_STATUS_TIMESTAMP_YESTERDAY": "Atzo",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE": "Txartel moldagarriaren analisi-errorea",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER": "Txartel moldagarriaren errendatze-errorea",
  "ATTACHMENT_AUDIO": "Audio zati bat.",
  "ATTACHMENT_CARD": "Txartel bat: $1 $2 $3",
  "ATTACHMENT_FILE": "Fitxategi bat: $1",
  "ATTACHMENT_IMAGE": "Irudi bat",
  "ATTACHMENT_TEXT": "Testu bat: $1",
  "ATTACHMENT_VIDEO": "Bideo zati bat",
  "AVATAR_ALT": "$1 abatarra",
  "CAROUSEL_FLIPPER_NEXT_ALT": "Hurrengoa",
  "CAROUSEL_FLIPPER_PREVIOUS_ALT": "Aurrekoa",
  "CITATION_MODEL_DIALOG_ALT": "Aipua",
  "CLOSE_BUTTON_ALT": "Itxi",
  "COLLAPSIBLE_GROUPING_TITLE": "Pentsatzen…",
  "COLLAPSIBLE_GROUPING_TITLE.comment": "Botak talde batean erantzun-mezuak idazten ari denean erakusten dira, abstrakziorik ematen ez bada.",
  "COLLAPSE_BUTTON_LESS": "Erakutsi gutxiago",
  "COLLAPSE_BUTTON_LESS.comment": "Hau da gezi-botoi baten testua mezu-multzo bat tolesteko. Azken erabiltzaileak botoian klik egiten duenean, mezu-taldea tolesten da.",
  "COLLAPSE_BUTTON_MORE": "Erakutsi gehiago",
  "COLLAPSE_BUTTON_MORE.comment": "Hau da gezi-botoi baten testua mezu-multzo bat zabaltzeko. Azken erabiltzaileak botoian klik egiten duenean, mezu-taldea zabaltzen da.",
  "CONNECTIVITY_STATUS_ALT_CONNECTED": "Konektatu da",
  "CONNECTIVITY_STATUS_ALT_CONNECTING": "Konektatzen…",
  "CONNECTIVITY_STATUS_ALT_FATAL": "Ezin da konektatu.",
  "CONNECTIVITY_STATUS_ALT_RECONNECTING": "Sareko konexioa eten egin da. Berriro konektatzen…",
  "CONNECTIVITY_STATUS_ALT_RENDER_ERROR": "Errendatze-errorea. Egiaztatu kontsola edo jarri harremanetan botaren garatzailearekin.",
  "CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION": "Ohi baino denbora gehiago behar izaten ari gara konektatzeko.",
  "CONNECTIVITY_STATUS_ALT": "Konexioaren egoera: $1",
  "COPY_BUTTON_TEXT": "Kopiatu",
  "COPY_BUTTON_COPIED_TEXT": "Kopiatuta",
  "FEEDBACK_FORM_SUBMIT_BUTTON_LABEL": "Bidali",
  "FEEDBACK_FORM_CANCEL_BUTTON_LABEL": "Utzi",
  "FEEDBACK_FORM_PLACEHOLDER": "Eman ahalik eta xehetasun gehien, baina ez sartu informazio pribatu edo kontuzkorik.",
  "FEEDBACK_FORM_TITLE": "Azaldu nolako esperientzia izan duzun",
  "FILE_CONTENT_ALT": "\"$1\"",
  "FILE_CONTENT_DOWNLOADABLE_ALT": "Deskargatu \"$1\" fitxategia",
  "FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT": "Deskargatu \"$1\" fitxategia (tamaina: $2)",
  "FILE_CONTENT_WITH_SIZE_ALT": "\"$1\" (tamaina: $2)",
  "MARKDOWN_EXTERNAL_LINK_ALT": "Beste leiho batean irekitzen da; kanpokoa.",
  "RECEIPT_CARD_TAX": "Zerga",
  "RECEIPT_CARD_TOTAL": "Guztira",
  "RECEIPT_CARD_VAT": "BEZ",
  "REFERENCE_LIST_HEADER_ONE": "$1 erreferentzia",
  "REFERENCE_LIST_HEADER_FEW": "$1 erreferentzia",
  "REFERENCE_LIST_HEADER_MANY": "$1 erreferentzia",
  "REFERENCE_LIST_HEADER_OTHER": "$1 erreferentzia",
  "REFERENCE_LIST_HEADER_TWO": "$1 erreferentzia",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_ALT": "Ezabatu $1 eranskina",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_TOOLTIP": "Ezabatu",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_FILE_ALT": "Fitxategi bat",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_IMAGE_ALT": "Irudi bat",
  "SEND_BOX_IS_EMPTY_TOOLTIP_ALT": "Ezin da mezu hutsik bidali.",
  "SPEECH_INPUT_LISTENING": "Entzuten…",
  "SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT": "Mikrofonoa desaktibatuta dago",
  "SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT": "Mikrofonoa aktibatuta dago",
  "SPEECH_INPUT_STARTING": "Hasten…",
  "SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT": "Hurrengoa",
  "SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT": "Aurrekoa",
  "SUGGESTED_ACTIONS_LABEL_ALT": "Iradokitako ekintzak",
  "TEXT_INPUT_ALT": "Mezua idazteko koadroa",
  "TEXT_INPUT_PLACEHOLDER": "Idatzi mezua",
  "TEXT_INPUT_SPEECH_IDLE_PLACEHOLDER": "Hasi hitz egiten...",
  "TEXT_INPUT_SPEECH_LISTENING_PLACEHOLDER": "Entzuten...",
  "TEXT_INPUT_SPEECH_PROCESSING_PLACEHOLDER": "Prozesatzen...",
  "TEXT_INPUT_SPEECH_BOT_SPEAKING_PLACEHOLDER": "Hitz egin eteteko...",
  "TEXT_INPUT_SEND_BUTTON_ALT": "Bidali",
  "TEXT_INPUT_SPEAK_BUTTON_ALT": "Hitz egin",
  "TEXT_INPUT_UPLOAD_BUTTON_ALT": "Kargatu fitxategia",
  "TEXT_INPUT_TELEPHONE_KEYPAD_BUTTON_ALT": "Telefonoaren teklatua",
  "TEXT_INPUT_DROP_ZONE": "Jaregin fitxategiak",
  "TEXT_INPUT_LENGTH_EXCEEDED_ALT": "Mezuaren luzera gainditu da",
  "TELEPHONE_KEYPAD_INPUT_MESSAGE": "Zifra bakarra gehi daiteke",
  "TEXT_INPUT_ATTACHMENTS_FEW": "$1 eranskin",
  "TEXT_INPUT_ATTACHMENTS_MANY": "$1 eranskin",
  "TEXT_INPUT_ATTACHMENTS_ONE": "1 eranskin",
  "TEXT_INPUT_ATTACHMENTS_OTHER": "$1 eranskin",
  "TEXT_INPUT_ATTACHMENTS_TWO": "$1 eranskin",
  "TOAST_ACCORDION_FEW": "$1 jakinarazpen. Egin klik hemen xehetasunak ikusteko",
  "TOAST_ACCORDION_MANY": "$1 jakinarazpen. Egin klik hemen xehetasunak ikusteko",
  "TOAST_ACCORDION_OTHER": "$1 jakinarazpen. Egin klik hemen xehetasunak ikusteko",
  "TOAST_ACCORDION_TWO": "$1 jakinarazpen. Egin klik hemen xehetasunak ikusteko",
  "TOAST_ALT_ERROR": "Errorea",
  "TOAST_ALT_INFO": "Informazioa",
  "TOAST_ALT_SUCCESS": "Gauzatu da",
  "TOAST_ALT_WARN": "Abisua",
  "TOAST_DISMISS_BUTTON": "Baztertu",
  "TOAST_TITLE_ALT": "Jakinarazpena",
  "TRANSCRIPT_ARIA_LABEL_ALT": "Txat-historia. Nabigatzeko, erabili Gora eta Behera geziak.",
  "TRANSCRIPT_ARIA_ROLE_ALT": "txat-historia",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT": "Mezua interaktiboa da. Sakatu Maius + tabulazio-tekla 2 edo 3 aldiz txat-historiara aldatzeko. Ondoren, sakatu mezua harekin elkarrekintzan jarduteko.",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT": "Esteka bat edo gehiago daude mezuan. Sakatu Maius + tabulazio-tekla 2 edo 3 aldiz txat-historiara aldatzeko. Ondoren, sakatu mezua harekin elkarrekintzan jarduteko.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT": "Mezuarekin lotutako ekintza iradokiak daude. Haiek hautatzeko, sakatu Maius fitxa 2 edo 3 aldiz.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT": "Mezuarekin lotutako ekintza iradokiak daude. Haiek hautatzeko, sakatu $1.",
  "TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT": "Ezin izan da bidali mezua.",
  "TRANSCRIPT_LIVE_REGION_NEW_MESSAGES_ALT": "Mezu berriak daude. Sakatu $1 \"$2\" botoia fokuratzeko.",
  "TRANSCRIPT_MORE_MESSAGES": "Mezu gehiago",
  "TRANSCRIPT_NEW_MESSAGES": "Mezu berriak",
  "TRANSCRIPT_TERMINATOR_TEXT": "Txat-historiaren amaiera",
  "TYPING_INDICATOR_ALT": "Idazketa-adierazlea ikusgai dago",
  "TYPING_INDICATOR_SINGLE_TEXT": "$1 idazten ari da.",
  "TYPING_INDICATOR_MULTIPLE_TEXT": "$1 eta beste batzuk idazten ari dira.",
  "VIEW_CODE_BUTTON_TEXT": "Kodea",
  "VOTE_COMPLETE_ALT": "Erregistratu dira oharrak",
  "VOTE_COMPLETE_ALT.comment": "Hau pantaila-irakurgailurako da. Erpurua gora/behera ikonoak dituen botoi baten etiketa. Oharrak erregistratu direnean erabiltzen da etiketa.",
  "VOTE_DISLIKE_ALT": "Ez dut atsegin",
  "VOTE_LIKE_ALT": "Atsegin dut"
}